import React from 'react';
import { css } from '@emotion/react';
import { BirdiTheme } from '@birdi/theme';
import BirdiLogoSVG from '@birdi/icons/birdi-logo-navy.svg';
import MapAccessLockSVG from '@birdi/icons/map-access-lock.svg';
import { AnchorButton } from '@birdi/components-common';
import { auth, stroot } from '@birdi/js-sdk';

export const AccountLocked: React.FC = () => {
  return (
    <div
      css={(theme: BirdiTheme) => css`
        position: absolute;
        inset: 0;
        width: 100%;
        height: 100%;
        background: ${theme.sand};
        display: flex;
        flex-direction: column;
      `}
    >
      <header
        css={(theme: BirdiTheme) => css`
          display: flex;
          align-items: center;
          height: 60px;
          width: 100%;
          background: ${theme.dove};
          padding-inline: 1rem;
          box-sizing: border-box;
        `}
      >
        <div
          css={css`
            font-size: 3em;
          `}
        >
          <BirdiLogoSVG />
        </div>
      </header>
      <div
        css={css`
          display: flex;
          align-items: center;
          justify-content: center;
          height: 100%;
        `}
      >
        <main
          css={(theme: BirdiTheme) => css`
            display: flex;
            flex-direction: column;
            align-items: center;
            background: ${theme.white};
            border-radius: 20px;
            padding: 2rem;
            gap: 1rem;
            box-sizing: border-box;
            max-width: 500px;
            width: 100%;
          `}
        >
          <header
            css={(theme: BirdiTheme) => css`
              display: flex;
              align-items: center;
              justify-content: center;
              gap: 1.5rem;
              border-bottom: solid 2px ${theme.sand};
              padding-bottom: 1rem;
              font-size: 24px;
              width: 100%;
              margin-bottom: 0.5rem;
            `}
          >
            <div
              css={css`
                display: flex;
                align-items: center;
                justify-content: center;
              `}
            >
              <MapAccessLockSVG width="40px" height="40px" />
            </div>
            <div
              css={css`
                display: flex;
                align-items: center;
                justify-content: center;
              `}
            >
              <BirdiLogoSVG
                width="55px"
                height="auto"
                css={css`
                  bottom: 12px;
                  position: relative;
                `}
              />
            </div>
          </header>

          <h1
            css={css`
              margin: 0;
              font-size: 20px;
              font-weight: 600;
            `}
          >
            Account Access Unavailable
          </h1>
          <p
            css={css`
              margin: 0;
              margin-bottom: 0.5rem;
              max-width: 350px;
            `}
          >
            It looks like you no longer have access to this account.
          </p>
          <p>This could be because:</p>
          <ul
            css={(theme: BirdiTheme) => css`
              color: ${theme.midnight};
              font-size: 1rem;
              margin: 0 0 0 1.2em;
              padding: 0;
              list-style: disc inside;
              max-width: 350px;
            `}
          >
            <li>Your subscription is no longer active</li>
            <li>Your account was removed by an admin</li>
            <li>Or your access has been paused for another reason</li>
          </ul>
          <p
            css={(theme: BirdiTheme) => css`
              color: ${theme.midnight};
              font-size: 1rem;
              margin-bottom: 0.5rem;
              max-width: 350px;
            `}
          >
            If you think this is a mistake or you'd like to regain access,
            please{' '}
            <a
              href="mailto:support@birdi.io"
              css={(theme: BirdiTheme) => css`
                color: ${theme.deepOcean};
                text-decoration: none;
                &:hover {
                  text-decoration: underline;
                }
              `}
            >
              support@birdi.io
            </a>{' '}
            or reach out to your account admin.
          </p>
          <div
            css={(theme: BirdiTheme) => css`
              color: ${theme.midnight};
              font-size: 1.1rem;
              font-weight: 500;
              margin-bottom: 0.5rem;
            `}
          >
            We're here to help!
          </div>
          <AnchorButton
            onClick={() => {
              auth.clearCookie(stroot('28dgur')).then(() => {
                window.location.href = '/sign-in';
              });
            }}
            css={css`
              align-self: center;
              width: 100%;
            `}
          >
            Return to Birdi log in screen
          </AnchorButton>
        </main>
      </div>
    </div>
  );
};
